import { RefreshCw } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { errText, frDateTime } from "@/components/prospect/common";

const LBL = { en_cours: "En cours", termine: "Terminé", erreur: "Erreur" };
const TRIG = { manuel: "Manuel", auto: "Automatique", webhook: "Webhook Lobstr" };

export function LogsTab() {
  const [logs, setLogs] = useState(null);
  const load = useCallback(() => api.get("/prospect/sync/logs").then(({ data }) => setLogs(data)).catch((e) => toast.error(errText(e))), []);
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);
  const sync = () => api.post("/prospect/sync").then(() => { toast.success("Synchronisation lancée."); setTimeout(load, 1500); }).catch((e) => toast.error(errText(e)));
  return (
    <div data-testid="prospect-logs-tab">
      <div className="ps-toolbar"><button type="button" className="primary-button" onClick={sync} data-testid="sync-now-btn"><RefreshCw size={15} /> Synchroniser maintenant</button></div>
      <table className="ps-table" data-testid="sync-logs-table">
        <thead><tr><th>Date</th><th>Déclencheur</th><th>Squid</th><th>Statut</th><th>Reçus</th><th>Nouveaux</th><th>Mis à jour</th><th>Doublons</th><th>Sans téléphone</th><th>Erreurs</th></tr></thead>
        <tbody>{logs?.map((l) => (
          <tr key={l.id}><td>{frDateTime(l.started_at)}</td><td>{TRIG[l.trigger] || l.trigger}</td><td>{l.squid_name}</td><td><span className={`ps-status st-${l.status === "erreur" ? "cloture" : l.status === "en_cours" ? "en_cours" : "plein"}`} title={l.error}>{LBL[l.status]}</span></td><td>{l.received ?? "—"}</td><td>{l.new ?? "—"}</td><td>{l.updated ?? "—"}</td><td>{l.duplicates ?? "—"}</td><td>{l.skipped ?? "—"}</td><td>{l.errors ?? (l.error ? 1 : "—")}</td></tr>
        ))}</tbody>
      </table>
      {logs?.length === 0 && <p className="pl-muted ps-empty">Aucune synchronisation pour l'instant.</p>}
    </div>
  );
}
